<div class="row mt-5">
	<div class="col need-help">
		<div 
			[attr.data-content]="'need_help' | translate" 
			class="need-help-text flex flex-row"
		>
		</div>
		<div class="d-flex justify-content-center mt-5">
			<a href="https://www.facebook.com/share/1GR6tqtn3J/" target="_blank"> 
				<!--https://www.facebook.com/shwetigerapp/      // https://www.facebook.com/ShweTigerOfficial?mibextid=ZbWKwL-->
				<img src="assets/img/common/facebook.png" alt="facebook">
			</a>
			<a 
				[href]="'viber://chat?number='+phone_no | safeUrl" 
				class="ml-3"
			>
				<img src="assets/img/common/viber.png" alt="viber">
			</a>
			<a [href]="'https://t.me/stiger004' | safeUrl" class="ml-3">
				<img src="assets/img/common/telegram.png" alt="telegram">
			</a>
		</div>
	</div>
</div>